export function parseRoles(roles) {
  if (!roles) {
    return []
  }
  if (Array.isArray(roles)) {
    return roles.map(role => `${role}`.trim()).filter(Boolean)
  }
  if (typeof roles !== 'string') {
    return []
  }
  return roles
    .replace(/\[/g, '')
    .replace(/\]/g, '')
    .replace(/"/g, '')
    .replace(/'/g, '')
    .split(',')
    .map(role => role.trim())
    .filter(Boolean)
}

export function hasRole(roles, role) {
  return parseRoles(roles).indexOf(role) >= 0
}

export function hasAnyRole(roles, requiredRoles) {
  const roleList = parseRoles(roles)
  return requiredRoles.some(role => roleList.indexOf(role) >= 0)
}

